import React from 'react'

import Form from '../../atoms/form/Form'
import Card from '../../atoms/card/Card'
import Text from '../../atoms/text/Text'
import { formatSimulationState } from '../../pages/simulations/lib/formatters'
import { GeneralDisplay } from '../../pages/simulations/steps/general'
import { PlayersDisplay } from '../../pages/simulations/steps/players'
import { ModuleDisplay } from '../../pages/simulations/steps/module'
import { RegionDisplay } from '../../pages/simulations/steps/region'
import { BusinessDisplay } from '../../pages/simulations/steps/business'
import { DealRoomDisplay } from '../../pages/simulations/steps/dealroom'
import { ExcoDecisionDisplay } from '../../pages/simulations/steps/excodecision'
import { SummaryDisplay } from '../../pages/simulations/steps/summary'
import { FinancialScreenDisplay } from '../../pages/simulations/steps/financial-summary'
import { SpecialProjectsDisplay } from '../../pages/simulations/steps/special-projects/Index'
import { HelpManualDisplay } from '../../pages/simulations/steps/resources'
import { MetadataDisplay } from '../../pages/simulations/steps/metadata'

interface Props {
  simulation: API.SimulationResponse
}

const SimulationPreviewWithData: React.FC<Props> = ({simulation: data}) => {

  return (
    <Form>
      <Card wide>
        <h4>Status</h4>
        <Text size='sm' bold colour={data.state === 'draft' ? 'danger' : 'green'}>{formatSimulationState(data)}</Text>
      </Card>
      <GeneralDisplay data={data} />
      <PlayersDisplay data={data?.playersSetup} />
      <ModuleDisplay data={data?.moduleSetup} />
      <RegionDisplay data={data?.regionalSetup} />
      <BusinessDisplay data={data?.businessSetup} />
      <DealRoomDisplay data={data} />
      <ExcoDecisionDisplay data={data} />
      <SummaryDisplay data={data?.summaryMetrics} config={data?.summaryMetricConfig} />
      <FinancialScreenDisplay data={data?.financialSummaryMetrics} config={data?.financialSummaryMetricConfig} />
      <SpecialProjectsDisplay data={data?.specialProjectsSetup} />
      <HelpManualDisplay data={data?.resources} />
      <MetadataDisplay data={data?.metadata} />
    </Form>
  )
}

export default SimulationPreviewWithData
